import "./Legal.module.css";
import TrendMitraNavigationHeader from "@/reusable_sections/Header";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import TerminalFooter from "@/reusable_sections/Footer";
export default function LegalPage() {
  return <div>
      <TrendMitraNavigationHeader />
      <PrivacyPolicy />
      <TerminalFooter />
    </div>;
}